import { ACReactRouterLink } from 'academy-common-lib/components/ACReactRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
const DrilldownLink = ({
  to,
  aggregationTotal
}) => {
  if (aggregationTotal > 0) {
    return /*#__PURE__*/_jsx(ACReactRouterLink, {
      to: to,
      children: aggregationTotal
    });
  }
  return aggregationTotal;
};
export default DrilldownLink;